import React, { useEffect } from "react";
import { useAppDispatch } from "redux/store/hooks";
import { getAuthUserProfile, getExpertProfile } from "redux/actions";
import { useAuthSelectors } from "redux/selectors";
import { Roles } from "redux/reducers";

const AuthHooks = () => {
  const dispatch = useAppDispatch();

  const { selectAuthUser } = useAuthSelectors();

  useEffect(() => {
    if (selectAuthUser) dispatch(getAuthUserProfile());
  }, []);

  useEffect(() => {
    if (selectAuthUser?.isExpert === Roles.expert) dispatch(getExpertProfile());
  }, [selectAuthUser]);

  return <></>;
};

export default AuthHooks;
